import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var User = namespace('user');

var WalmartAuthorizing = function (_super) {
  __extends(WalmartAuthorizing, _super);

  function WalmartAuthorizing() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.message = _this.t('授权处理中，请稍等');
    _this.loading = true;
    return _this;
  }

  WalmartAuthorizing.prototype.created = function () {
    var _this = this;

    this.$router.onReady(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var urlData;
        return __generator(this, function (_a) {
          if (this.userInfo.user_code) {
            this.$router.replace({
              name: 'PlatformAccountPage',
              params: {
                openWalmart: String(this.$enum.common.Enabled.YES)
              }
            });
            return [2];
          }

          urlData = this.$router.resolve({
            name: 'PlatformWalmartAuthorizing'
          });
          this.$router.replace({
            path: '/login',
            query: {
              redirect_url: urlData.href
            }
          });
          return [2];
        });
      });
    });
  };

  __decorate([User.State('userInfo')], WalmartAuthorizing.prototype, "userInfo", void 0);

  WalmartAuthorizing = __decorate([Component], WalmartAuthorizing);
  return WalmartAuthorizing;
}(Vue);

export default WalmartAuthorizing;